import { makeAutoObservable, runInAction } from 'mobx';
import type { ResponseDataRow } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi, ControlDto } from '@src/api';

export type ControlDtoDefId = Omit<ControlDto, 'id'> & {
  id: string;
  reportGroupName?: string;
  ctrlGroupCode?: string;
  ctrlGroupName?: string;
};

export type Filters = {
  reportGroup?: string;
  controlGroup?: string;
};

class ControlsStore {
  controls: ControlDtoDefId[] = [];

  api: CmApi;

  filters: Filters = {};

  breadcrumbs: string[] = [];

  fullSize = false;

  selectNode: ControlDtoDefId | null = null;

  selectedKeys: string[] = [];

  expandedKeys: string[] = [];

  checked: ResponseDataRow[] = [];

  isChanged = false; // флаг, что справочник изменился для проверки загрузки в fetchReferences

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setIsChanged = (value: boolean) => {
    this.isChanged = value;
  };

  setFilters = (filter: Filters) => {
    this.filters = filter;
  };

  setBreadcrumbs = (value: string[]) => {
    this.breadcrumbs = value;
  };

  toggleFullSize = () => {
    this.fullSize = !this.fullSize;
  };

  setSelectNode = (value: ControlDtoDefId | null) => {
    this.selectNode = value;

    if (value === null) {
      this.fullSize = false;
    }
  };

  setSelectedKeys = (value: string[]) => {
    this.selectedKeys = value;
  };

  setExpandedKeys = (value: string[]) => {
    this.expandedKeys = value;
  };

  setChecked = (value) => {
    this.checked = value;
  };

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.controls.getControls();

    runInAction(() => {
      this.controls = data?.map((item) => ({ ...item, id: item.ctrlCode ?? '' })) ?? [];
      this.isChanged = false;
    });
    preloaderStore.preloader(false);
  };

  groupDelete = async (controls: ControlDtoDefId[]) => {
    preloaderStore.preloader(true, 'удаление...');
    const promises = controls.map((item) => this.api.controls.deleteControlByCode(item.ctrlCode ?? ''));
    await Promise.all(promises);
    await this.fetch();
    preloaderStore.preloader(false);
  };

  clear = () => {
    this.filters = {};
    this.breadcrumbs = [];
    this.fullSize = false;
    this.selectNode = null;
    this.selectedKeys = [];
    this.expandedKeys = [];
    this.checked = [];
  };
}

export const controlsStore = new ControlsStore({ api: cmApi });
